import { cn } from '@/lib/utils';
import { AlertTriangle } from 'lucide-react';
import { useLocale } from '../../hooks/useLocale';

export interface NotFoundStateProps {
	title?: string;
	description?: string;
	icon?: React.ReactNode;
	className?: string;
}

const NotFoundState = ({
	title,
	description,
	icon = <AlertTriangle className="w-10 h-10 text-warning" />,
	className = '',
}: NotFoundStateProps) => {
	const { t: tGeneric } = useLocale('generic');
	return (
		<div
			className={cn(
				'flex flex-col items-center justify-center text-center p-6 border border-dashed border-background-border rounded-lg bg-background',
				className
			)}
		>
			<div className="mb-4">{icon}</div>
			<h3 className="text-lg font-semibold">
				{title ?? tGeneric('notFound')}
			</h3>
			<p className="text-sm text-muted mt-1">
				{description ?? tGeneric('notFoundDescription')}
			</p>
		</div>
	);
};

export default NotFoundState;
